import { render } from "./LandingLanguageSwitcher.vue?vue&type=template&id=196da029"
import script from "./LandingLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LandingLanguageSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__